export const LoginMetadataKey = "LoginMetadata";
export const LoginMetadataExpiry = 30*24*60*60;

export const NewsKey = "News";
export const NewsExpiry = 60*60;

export const chaptersKey = "chapters";
export const chaptersExpiry =  30*24*60*60;

export const memberprofileKey = "memberProfile";
export const memberprofileExpiry =  24*60*60;

export const userprofileKey = "userProile";
export const userprofileExpiry =  24*60*60;

export const activeMembership = "activeMembership";
export const activeMembershipExpiry =  24*60*60;


export const OffersKey = "Offers";
export const OffersExpiry = 24*60*60;

export const OffersDetailKey = "OffersDetail";
export const OffersDetailExpiry = 24*60*60;

export const AllTicketsKey = "AllTickets";
export const AllTicketsExpiry = 5*60;

export const AllChapterTicketsKey = "AllChapterTickets";
export const AllChapterTicketsExpiry = 5*60;

export const GetTicketKey = "GetTicket";
export const GetTicketExpiry = 60*60;

export const MyIIASliderImageKey = "MyIIASlider";
export const MyIIASliderExpiry = 24*60*60;

export const MyIIALeadersKey = "MyIIALeaders";
export const MyIIALeadersExpiry = 24*60*60;


export const insertPaymentKey = "InsertPayment";
export const insertPaymentExpiry =  24*60*60;

export const GetEnquiryStatus = "GetEnquiry";
export const GetEnquiryStatusExpiry =  24*60*60;

export const GetItemsStatus = "GetItems";
export const GetItemStatusExpiry =  24*60*60;

export const BuyerItemsList = "BuyerItemsList";
export const BuyerItemListExpiry = 24*60*60;

export const B2BAdminDashboard = "B2BAdminDashboard";
export const B2BAdminDashboardExpiry = 24*60*60;

export const B2BAdminEnquiries = "B2BAdminEnquiries";
export const B2BAdminEnquiriesExpiry = 24*60*60;

export const B2BAdminListings = "B2BAdminListings";
export const B2BAdminListingsExpiry = 24*60*60;

export const EventPopOverURL = "EventPopOver/EventUrl";
export const EventPopOverURLExpiry = 24*60*60;

export const ShowEventPopOver = "ShowEventPop/ShowPopOver";
export const ShowEventPopOverExpiry = 24*60*60;


export const TableContentKey = "MemberClickedData";
export const TableContentExpiry = 24*60*60;

export const MagazineKey = "Magazine";
export const MagazineExpiry = 60*60;

export const IIADirectoryKey = "IIADirectory";
export const IIADirectoryExpiry = 24*60*60;